<button class="close" mat-button (click)="onClickNo()">X</button>
<h2>
  {{pollMessage.message}}
</h2><br/>
<table>
  <tr>
    <th *ngFor="let data of optionNameList;">{{data}}</th>
  </tr>
  <tr *ngFor="let data of tableData1, let rowIndex = index">
    <td>{{data.opt}}</td>
    <td *ngFor="let data1 of data.value; let colIndex = index">
      <input type="checkbox" [(ngModel)]="data1.val" (change)='handleClick(rowIndex,colIndex,$event);' [disabled]="data1.disable" class="ch-box">
  </tr>
</table>